import React,{useEffect,useContext,FC,useState} from 'react';
import "./DeviceRegistrationContainer.scss";
import {LicenseInputComp} from "./LicenseInputComp";
import { invokeKeyboard } from '../../KeyboardUtils/KeyboardHookUtils';
import { AppContext } from "../../../Context/Context"
import { PropsType , FixMeLater } from './DeviceRegistrationContainerTypes';
import axios from 'axios';
import AppService from '../../../CommonUtils/AppService';
import keyImage from "../../../Images/key.png";
import { checkIfKeyboardContainerExists } from '../../KeyboardUtils/KeyboardHookUtils';
import AlertTextComponent from './AlertTextComponent';
import InstanceDropdownComp from './InstanceDropdownComp';
import {useSetRecoilState} from "recoil";
import {spinnerOverlayAtom} from "../../../Recoil State/Atoms/AppAtoms";

export const DeviceRegistrationContainer : FC <PropsType> = ({heading}) => {

    const [showAlertText,setShowAlertText]=useState(false);
    const [AlertText,setAlertText]=useState("");
    const [licenseKey, setLicenseKey] = useState("");
    const [selectedInstanceLicenseKey, setSelectedInstanceLicenseKey] = useState("");
    const [licenseInstances, setLicenseInstances] = useState([]);

    let {setKeyboardVisibility} : FixMeLater=useContext(AppContext);
    const spinnerOverlaySetter = useSetRecoilState(spinnerOverlayAtom);

    useEffect(()=>{
        const keyboardCheckIntervalId = setInterval(()=>{
            let keyboardExistsFlag = checkIfKeyboardContainerExists();
            if(keyboardExistsFlag) {
                setKeyboardVisibility(true);
                invokeKeyboard(null,"");
                clearInterval(keyboardCheckIntervalId);
            }   
        },300);
    },[]);
    
    useEffect(()=>{

        const removeTrailingSlash=(url:string) =>{
            if (url.endsWith('/')) {
              return url.slice(0, -1);
            }
            return url;
        }

        AppService.appInfoApiUrl=removeTrailingSlash(window.location.href)+'/getappinfo';
        //devdebug
       // AppService.appInfoApiUrl = "https://ig-apim-dev.azure-api.net/AppInstaller/getappinfo";

        axios.get(AppService.appInfoApiUrl)
        .then((response)=>{
             AppService.subscriptionKey=response.data.Authorization.SubscriptionKey;
             AppService.cdlsApiUrl=response.data.Authorization.Url;
             AppService.headerRequestFormat={...AppService.headerRequestFormat,headers:{...AppService.headerRequestFormat.headers,"Ocp-Apim-Subscription-Key":response.data.Authorization.SubscriptionKey}};


            //devdebug
            //AppService.subscriptionKey="69e075ed202444d2a41c2882d2d535f1";
            //AppService.cdlsApiUrl="https://ig-apim-dev.azure-api.net/cdls-api/";
            //AppService.headerRequestFormat={...AppService.headerRequestFormat,headers:{...AppService.headerRequestFormat.headers,"Ocp-Apim-Subscription-Key":AppService.subscriptionKey}};
      
        })
        .catch((err)=>{
            
        })
    },[]);

    const handleInstanceSelect = (registrationKey: string) => {
        setSelectedInstanceLicenseKey(registrationKey);
    };

    const handleLicenseKeyChange = (key: string) => {
        setLicenseKey(key);
    };

    // Call License Decider API when license key changes
    useEffect(() => {
        const callLicenseDeciderAPI = async () => {
            if (!licenseKey) {
                setLicenseInstances([]);
                setSelectedInstanceLicenseKey("");
                return;
            }
            
            setSelectedInstanceLicenseKey("");
            spinnerOverlaySetter({
                displayOverlay: true,
                displaySpinner: true,
            });

            try {
                const response = await axios.post(
                    AppService.getLicenseDecider,
                    {
                        RegisterationKey: licenseKey,
                        AppType: AppService.deviceRegistrationRequest.AppType,
                        ModuleTypeId: 0
                    },
                    AppService.headerRequestFormat
                );
                setShowAlertText(false);
                setAlertText("");
                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                    setLicenseInstances(response.data);
                    
                    if (response.data.length === 1) {
                        const selectedKey = response.data[0].RegisterationKey;
                        setSelectedInstanceLicenseKey(selectedKey);
                    }
                } else {
                    setLicenseInstances([]);
                }
            } catch (error) {
                setAlertText(error.response && error.response.data && error.response.status != 400 ? error.response.data : "Please Enter Valid License Key");
                setLicenseInstances([]);
                setShowAlertText(true)
            } finally {
                spinnerOverlaySetter({
                    displayOverlay: false,
                    displaySpinner: false,
                });
            }
        };

        callLicenseDeciderAPI();
    }, [licenseKey]);
    
  return (
    <div className="device-regpage">
        <div className="device-regpage-heading">
            {heading}
        </div>
        <div className="device-regpage-license">
            <div className="device-regpage-license-label">
                License Key
            </div>
            <div className="device-regpage-license-input">
                <div className="device-regpage-license-input-icon">
                <img src={keyImage} alt="keyimage"/>
                </div>
                <div className="device-regpage-license-input-field">
                <LicenseInputComp 
                    type="text" 
                    placeholder="XXXXXX-XXXXXX-XXXXXX-XXXXXX" 
                    initialVal="" 
                    showAlertText={showAlertText} 
                    setShowAlertText={setShowAlertText}
                    onLicenseKeyChange={handleLicenseKeyChange}
                    selectedInstanceLicenseKey={selectedInstanceLicenseKey}
                    setAlertText={setAlertText}
                />
                </div>
            </div>
            {showAlertText && <AlertTextComponent alertText={AlertText} />}
            <InstanceDropdownComp
                licenseInstances={licenseInstances}
                selectedInstanceKey={selectedInstanceLicenseKey}
                appType={AppService.deviceRegistrationRequest.AppType}
                onInstanceSelect={handleInstanceSelect}
            />
        </div>
        
    </div>
  )
}


export default React.memo(DeviceRegistrationContainer);